export const PERMISSION_MODULE = Object.freeze({
  CUSTOMER: 'CUSTOMER',
  SETTING: 'SETTING',
  VIETLOTT: 'VIETLOTT',
  CLASSIC: 'CLASSIC',
  LOTO: 'LOTO'
})

export const PERMISSION_INDEX = Object.freeze({
  [PERMISSION_MODULE.CUSTOMER]: 0,
  [PERMISSION_MODULE.SETTING]: 1,
  [PERMISSION_MODULE.VIETLOTT]: 2,
  [PERMISSION_MODULE.CLASSIC]: 3,
  [PERMISSION_MODULE.LOTO]: 4
})

export const PERMISSION_MODULES = [
  { key: PERMISSION_MODULE.CUSTOMER, index: PERMISSION_INDEX[PERMISSION_MODULE.CUSTOMER], label: 'Khách hàng' },
  { key: PERMISSION_MODULE.SETTING, index: PERMISSION_INDEX[PERMISSION_MODULE.SETTING], label: 'Cài đặt' },
  { key: PERMISSION_MODULE.VIETLOTT, index: PERMISSION_INDEX[PERMISSION_MODULE.VIETLOTT], label: 'Vietlott' },
  { key: PERMISSION_MODULE.CLASSIC, index: PERMISSION_INDEX[PERMISSION_MODULE.CLASSIC], label: 'Classic' },
  { key: PERMISSION_MODULE.LOTO, index: PERMISSION_INDEX[PERMISSION_MODULE.LOTO], label: 'Loto' }
]

export const normalizePermission = (permission = '', length = 5) => {
  const cleaned = `${permission || ''}`.replace(/\s+/g, '')

  // Backward-compat: older admins used 2-bit string: [vietlott, classic]
  // Current format is 5-bit string: [customer, setting, vietlott, classic, loto]
  if (cleaned.length === 2 && /^[01]{2}$/.test(cleaned)) {
    const [vietlott, classic] = cleaned.split('')
    return `00${vietlott}${classic}0`
  }

  return cleaned.padEnd(length, '0').slice(0, length)
}

export const getEnabledPermissionModules = (permission = '') => {
  const normalized = normalizePermission(permission)
  return PERMISSION_MODULES.filter((module) => normalized[module.index] === '1')
}

export const getPermissionLabels = (permission = '') => {
  return getEnabledPermissionModules(permission).map((module) => module.label)
}

export const formatPermissionText = (permission = '') => {
  const labels = getPermissionLabels(permission)
  return labels.length > 0 ? labels.join(', ') : 'Không có quyền'
}

export const countEnabledPermissions = (permission = '') => {
  return getEnabledPermissionModules(permission).length
}

export const hasMultiplePermissions = (permission = '') => {
  return countEnabledPermissions(permission) > 1
}

export const canCreateEmployees = () => {
  try {
    const permission = localStorage.getItem('permission') || ''
    return hasMultiplePermissions(permission)
  } catch (e) {
    return false
  }
}
